import React, { useEffect, useRef } from 'react';
import { Animated, Easing, Platform } from 'react-native';

interface AnimatedRippleProps {
  delay?: number;
  duration?: number;
  size?: number;
  borderColor?: string;
  backgroundColor?: string;
}

export function AnimatedRippleCirle({
  delay = 0,
  duration = 2000,
  size,
  borderColor = '#000',
  backgroundColor = '#fff',
}: AnimatedRippleProps) {
  const ripperAnimation = useRef(new Animated.Value(0));

  useEffect(() => {
    const animation = Animated.loop(
      Animated.timing(ripperAnimation.current, {
        toValue: 1,
        useNativeDriver: Platform.OS !== 'web',
        duration,
        delay,
        easing: Easing.out(Easing.ease),
      }),
      { iterations: -1, resetBeforeIteration: true },
    );

    animation.start();

    return () => {
      animation.reset();
      animation.stop();
    };
  }, [delay, duration]);

  const opacityAnimation = ripperAnimation.current.interpolate({
    inputRange: [0, 1],
    outputRange: [1, 0],
    extrapolate: 'clamp',
  });

  const scaleAnimation = ripperAnimation.current.interpolate({
    inputRange: [0, 1],
    outputRange: [1, 2],
    extrapolate: 'clamp',
  });

  return (
    <Animated.View
      // eslint-disable-next-line react-native/no-inline-styles
      style={{
        width: size,
        height: size,
        borderWidth: 1,
        borderColor,
        borderRadius: 1000,
        position: 'absolute',
        opacity: opacityAnimation,
        backgroundColor,
        transform: [{ scale: scaleAnimation }],
      }}
    />
  );
}
